function animateScrollTop(htmlData) {
  let isWeb = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPod',
    'iPad'
  ]
  for (let i = 0; i < isWeb.length; i++) {
    if (navigator.userAgent.indexOf(isWeb[i]) >= 0) {
      $('html, body').animate(
        { scrollTop: $('#' + htmlData).offset().top - 80 },
        1000
      )
      return
    } else {
      $('html, body').animate(
        { scrollTop: $('#' + htmlData).offset().top - 190 },
        1000
      )
      return
    }
  }
}
$(function () {
  let fraction = {
    0: 0,
    0.125: '1/8',
    0.25: '1/4',
    0.375: '3/8',
    0.5: '1/2',
    0.625: '5/8',
    0.75: '3/4',
    0.875: '7/8'
  }
  let basicBefore,
    decimalBefore,
    basicAfter,
    decimalAfter,
    middleNumArr,
    afterArr,
    brforeValue
  let difference = []
  let qaStep = 0
  $('#bandInch').change(function () {
    initDecimalBefore()
    initBasicAfter()
    initDecimalAfter()
  })
  $('#bandInchNum').change(function () {
    initBasicAfter()
    initDecimalAfter()
  })
  $('#cupInch').change(function () {
    initDecimalAfter()
  })
  initBasicBefore()
  initDecimalBefore()
  initBasicAfter()
  initDecimalAfter()

  function initBasicBefore() {
    basicBefore = fittingBraJson.braSize.map((item, index) => {
      return item.basics
    })
    basicBefore = newArrFn(basicBefore)
    decimalBefore = Object.values(fraction)
    let target = {}
    basicBefore.forEach((val) => {
      target[val] = []
    })
    fittingBraJson.braSize.map((val) => {
      basicBefore.some((value) => {
        if (val.basics == value) {
          target[value].push(val)
          return
        }
      })
    })

    target[Object.keys(target)[0]].map((item, index) => {
      difference[0] = target[Object.keys(target)[0]][0].min
      difference[index + 1] = item.max
    })
    $('#bandInch').empty()
    basicBefore.forEach((item, index) => {
      $('#bandInch').append(`<option value="${item}">${item}</option>`)
    })
  }

  function initDecimalBefore() {
    $('#bandInchNum').empty()
    let sliceArr = decimalBefore
    let fractionArr = Object.keys(fraction)
    if (Number($('#bandInch  option:selected').val()) === basicBefore[0]) {
      sliceArr = decimalBefore.slice(-4)
      fractionArr = Object.keys(fraction).slice(-4)
    }
    if (
      Number($('#bandInch  option:selected').val()) ===
      basicBefore[basicBefore.length - 1]
    ) {
      sliceArr = decimalBefore.slice(0, 5)
      fractionArr = Object.keys(fraction).slice(0, 5)
    }
    sliceArr.forEach((item, index) => {
      $('#bandInchNum').append(
        `<option value="${fractionArr[index]}">${item}</option>`
      )
    })
  }

  function initBasicAfter() {
    $('#cupInch').empty()
    let basicBeforeValue = Number($('#bandInch  option:selected').val())
    let decimalBeforeValue = Number($('#bandInchNum  option:selected').val())
    brforeValue = basicBeforeValue + decimalBeforeValue
    afterArr = afterNumFun(
      brforeValue,
      difference[0],
      difference[difference.length - 1]
    )
    let basicAfterNum = afterArr.map((item, index) => {
      return Math.trunc(item)
    })
    basicAfterNum.forEach((item, index) => {
      $('#cupInch').append(`<option value="${item}">${item}</option>`)
    })
  }

  function initDecimalAfter() {
    $('#cupInchNum').empty()
    let sliceArr = Object.keys(fraction)
    let fractionValueArr = Object.values(fraction)
    let sliceIndex
    let basicAfterValue = Number($('#cupInch  option:selected').val())
    sliceArr = sliceArr.map((item) => {
      return Number(item)
    })
    if (basicAfterValue == Math.trunc(afterArr[0])) {
      sliceIndex = sliceArr.findIndex((item) => {
        return item == takeDecimalsFun(afterArr[0])
      })
      sliceArr = sliceArr.slice(sliceIndex)
      fractionValueArr = fractionValueArr.slice(sliceIndex)
    }
    if (basicAfterValue == Math.trunc(afterArr[afterArr.length - 1])) {
      sliceIndex = sliceArr.findIndex((item) => {
        return item == takeDecimalsFun(afterArr[afterArr.length - 1])
      })
      sliceArr = sliceArr.slice(0, sliceIndex + 1)
      fractionValueArr = fractionValueArr.slice(0, sliceIndex + 1)
    }
    sliceArr.forEach((item, index) => {
      $('#cupInchNum').append(
        `<option value="${item}">${fractionValueArr[index]}</option>`
      )
    })
  }

  function afterNumFun(num, min, max) {
    let minNum = num + min,
      maxNum = num + max,
      res = []
    if (minNum % 1) {
      res = [minNum]
    }
    for (let i = Math.ceil(minNum); i < Math.floor(maxNum); i++) {
      res.push(i)
    }
    res.push(maxNum)
    return res
  }

  function takeDecimalsFun(num) {
    return (num = num - parseInt(num))
  }

  function newArrFn(arr) {
    let newArr = []
    return arr.reduce((prev, next, index, arr) => {
      return newArr.includes(next) ? newArr : newArr.push(next)
    }, 0)
  }

  function toMonitorCompanyListT() {
    $('#showSizeT').hide()
    let cupNum = Number($('#cupInch  option:selected').val())
    let bandNUm = Number($('#bandInch  option:selected').val())
    let cupNumSal = Number($('#cupInchNum  option:selected').val())
    let bandNUmSal = Number($('#bandInchNum  option:selected').val())
    let sendData = {
      bandInch: bandNUm + bandNUmSal,
      cupInch: cupNum + cupNumSal
    }
    let res = fittingBraJson.braSize.filter((item) => {
      item.bandInch = item.basics + item.decimal
      item.cupInchMin = sendData.bandInch + item.min
      item.cupInchMax = sendData.bandInch + item.max
      return (
        sendData.bandInch >= item.bandInch &&
        bandNUm == item.basics &&
        item.cupInchMin <= sendData.cupInch &&
        sendData.cupInch <= item.cupInchMax
      )
    })
    console.log(res)

    if (res && res.length > 0) {
      $('.showSizeT').html(res[res.length - 1].result)
      qaDataVal.barSize = res[res.length - 1].result
      console.log(res[res.length - 1].result,'结果')
    } else {
      // $("#showSizeT").html(' YOUR RECOMMENDED SIZE:' + ' Sorry, inputs out of scope.')
    }
  }
  if ($(window).width() <= 767) {
  }

  let qaDataVal = {
    barSize: '',
    brand: "Victoria's Secret",
    breastShape: 'Round',
    occasion: 'All Day Favorites'
  }
  $(document).on(
    'click',
    '.findSize-bra-fit-qa-item-column-span-img',
    function (e) {
      $(this)
        .parents('.findSize-bra-fit-qa-item-column')
        .find('.findSize-bra-fit-qa-item-column-span-img')
        .removeClass('active')
      $(this).addClass('active')
      qaDataVal.breastShape = $(this).data('val')
    }
  )
  // $('#brand, #occasion').change(function() {
  //     if ($(this).val() !== '') {
  //         $("#clickSubT").removeAttr('disabled')
  //     }
  // })
  // 前进按钮
  $('#clickSubT').click(function () {
    $('#template').find('.findSize-bra-fit-qa-item').hide()
    if (qaStep === 0) {
      toMonitorCompanyListT()
      qaStep = 1
      $('.findSize-bra-fit-qa-progress-container').width('33.33%')
      $('.findSize-bra-fit-qa-progress-text').text('2/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(1).show()
      $('#clickSubB').show()
      $('.showSizeT').show()
      queryRecordBraFitQA({
        questionId: 0,
        question: 'Select Band Size',
        answer: qaDataVal.barSize,
        callback: (res) => {
          console.log(res)
        }
      })
    } else if(qaStep === 1){
      $('.findSize-bra-fit-qa-progress-container').width('50%')
      $('.findSize-bra-fit-qa-progress-text').text('3/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(2).show()

      qaStep = 2
    } else if (qaStep === 2) {
      $('.findSize-bra-fit-qa-progress-container').width('66.67%')
      $('.findSize-bra-fit-qa-progress-text').text('4/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(3).show()
      $('.findSize-bra-fit-qa-item-column-overflow-x').scrollLeft(0)
      qaDataVal.brand = $('#brand').val()
      qaStep = 3
      $('#clickSubB').show()
      queryRecordBraFitQA({
        questionId: 1,
        question: 'What is the favorite brand of your current bra?',
        answer: qaDataVal.brand,
        callback: (res) => {
          console.log(res)
        }
      })
    } else if (qaStep === 3) {
      $('.findSize-bra-fit-qa-progress-container').width('83.3%')
      $('.findSize-bra-fit-qa-progress-text').text('5/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(4).show()
      $('#clickSubB').show()
      animateScrollTop('point_02')
      qaStep = 4
      queryRecordBraFitQA({
        questionId: 2,
        question: 'Which breast shape do you have?',
        answer: qaDataVal.breastShape,
        callback: (res) => {
          console.log(res)
        }
      })
    } else if (qaStep === 4) {
      $('.findSize-bra-fit-qa-progress-container').width('100%')
      $('.findSize-bra-fit-qa-progress-text').text('6/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(5).show()
      toMonitorCompanyListT()
      qaStep = 5
      qaDataVal.occasion = []
      $("input:checkbox[name='occasion']:checked").each(function () {
        qaDataVal.occasion.push($(this).val()) //向数组中添加元素
      })
      console.log(qaDataVal.occasion)
      queryRecordBraFitQA({
        questionId: 3,
        question: 'What occasion to wear a bra?',
        answer: qaDataVal.occasion.toString(),
        callback: (res) => {
          console.log(res)
        }
      }
      )

      $('.showSizeT').show()
      $('#clickSubT').hide()
      $('#clickSubB').hide()
      // $('.findSizeItemF8').hide()
      getBraFitProduct()}
  })

  //后退按钮
  $('#clickSubB').click(function () {
    $('#template').find('.findSize-bra-fit-qa-item').hide()
    if (qaStep === 1) {
      $('.findSizeItemF8').show()
      $('.findSize-bra-fit-qa-a').hide()
      $('#template').find('.findSize-bra-fit-qa-item').hide().eq(0).show()
      $('.findSize-bra-fit-qa-progress-container').width('16.6%')
      $('.findSize-bra-fit-qa-progress-text').text('1/6')
      qaStep = 0
      $('#clickSubB').hide()
      $('.findSize-bra-fit-product').html('')
    } else if (qaStep === 2) {
      qaStepFun.qaStep0()
      animateScrollTop('point_02')
      qaStep = 1
    } else if (qaStep === 3) {
      qaStepFun.qaStep1()
      qaStep = 2
    } else if (qaStep === 4) {
      qaStepFun.qaStep2()
      qaStep = 3
    }else if (Step === 5) {
      qaStepFun.qaStep3()
      qaStep = 4
    }else if (Step === 6) {
        qaStepFun.qaStep4()
      qaStep = 5
    }
  })
  const qaStepFun = {
    qaStep0: () => {
      toMonitorCompanyListT()
      $('.findSize-bra-fit-qa-progress-container').width('33.3%')
      $('.findSize-bra-fit-qa-progress-text').text('2/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(1).show()
      $('#clickSubB').show()
    },
    qaStep1: () => {
      $('.findSize-bra-fit-qa-progress-container').width('50%')
      $('.findSize-bra-fit-qa-progress-text').text('3/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(2).show()
      $('.findSize-bra-fit-qa-item-column-overflow-x').scrollLeft(0)
      $('#clickSubB').show()
      qaDataVal.brand = $('#brand').val()
    },
    qaStep2: () => {
      $('.findSize-bra-fit-qa-progress-container').width('66.6%')
      $('.findSize-bra-fit-qa-progress-text').text('4/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(3).show()
      $('#clickSubB').show()
    },
    qaStep3: () => {
      $('.findSize-bra-fit-qa-progress-container').width('83.3%')
      $('.findSize-bra-fit-qa-progress-text').text('5/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(4).show()
      $('#clickSubB').show()
    },
    qaStep4: () => {
      $('.findSize-bra-fit-qa-progress-container').width('100')
      $('.findSize-bra-fit-qa-progress-text').text('6/6')
      $('#template').find('.findSize-bra-fit-qa-item').eq(5).show()
      $('#clickSubB').show()
    },
    qaStep5: () => {
      $('.findSize-bra-fit-qa-a').show()
      $('.findSizeItemF8').hide()
      $('#template').find('.findSize-bra-fit-qa-item').eq(0).show()
      $('.findSize-bra-fit-qa-progress-container').width('16.6%')
      $('.findSize-bra-fit-qa-progress-text').text('1/6')
      $('#clickSubB').hide()

      qaDataVal.occasion = $("input:[name='occasion']:checked").val()
      console.log(qaDataVal.occasion)
    }
  }
  $('.findSize-bra-fit-qa-a-link a').click(function () {
    if (theme.currentQuickbuyRequest) {
      theme.currentQuickbuyRequest.abort()
    }
    $('.findSizeItemF8').show()
    $('.findSize-bra-fit-qa-a').hide()
    $('#template').find('.findSize-bra-fit-qa-item').hide().eq(0).show()
    $('.findSize-bra-fit-qa-progress-container').width('16.6%')
    $('.findSize-bra-fit-qa-progress-text').text('1/6')
    qaStep = 0
    $('.findSize-bra-fit-product').html('')
    $('#clickSubB').hide()
    $('#clickSubT').show()
    // $('#brand').val('Victoria\'s Secret')
    // $('#occasion').val('All Day Favorites')
    // $('.findSize-bra-fit-qa-item-column-span-img').removeClass('active')
    // $('.findSize-bra-fit-qa-item-column-span-img').eq(0).addClass('active')
    // initBasicBefore()
    // initDecimalBefore()
    // initBasicAfter()
    // initDecimalAfter()
    // qaDataVal = {
    //     barSize: '',
    //     brand: 'Victoria\'s Secret',
    //     breastShape: 'Round',
    //     occasion: 'All Day Favorites',
    // }
  })
  let queryUrl = Shopify.routes.root + 'collections/find-my-bra-fit'
  function getBraFitProduct() {
    const params = {
      'filter.v.option.size': qaDataVal.barSize,
      'filter.p.m.custom.company': qaDataVal.brand,
      // 'filter.p.m.custom.occassion': qaDataVal.occasion,
      'filter.p.m.custom.bustfull': qaDataVal.breastShape
    }
    // ?filter.p.m.custom.bust_full=ci2&filter.p.m.custom.company=ci1&filter.p.m.custom.materials=jc&filter.p.m.custom.occassion=cj&filter.v.option.size=XS
    // queryUrl = `/collections/find-my-bra-fit?${urlEncode(params)}&${_breastShapeParams}`
    // queryUrl =
    //   Shopify.routes.root +
    //   `collections/find-my-bra-fit?filter.v.option.size=S&filter.v.option.size=M&filter.v.option.size=L&filter.v.option.size=XL&filter.v.option.size=XXL&${urlEncode(
    //     params
    //   )}&${urlOccasionEncode(qaDataVal.occasion)}`
    queryUrl =
        Shopify.routes.root +
        `collections/find-my-bra-fit?${urlEncode(params)}&${urlOccasionEncode(qaDataVal.occasion)}`
    // queryUrl = `/collections/find-my-bra-fit?filter.v.option.size=90`
    $('.findSize-bra-fit-product').html(
      '<div style="padding: 10px; text-align: center"><div class="loading-spinner"></div></div>'
    )
    window.theme.currentQuickbuyRequest = $.get(queryUrl, function (response) {
      let $newDetail = $('<div>' + response + '</div>').find(
        '.collection-listing'
      )
      if (
        $newDetail.find('.product-list').children('.product-block').length > 0
      ) {
        newDetailHtml($newDetail)
      } else {
        $('.findSize-bra-fit-product').html(
          '<div style="padding: 10px; text-align: center"><div class="loading-spinner"></div></div>'
        )
        theme.currentQuickbuyRequest.abort()
        window.theme.currentQuickbuyRequest = $.get(
          '/collections/find-my-bra-fit?sort_by=best-selling',
          function (res) {
            let $newDetailAll = $('<div>' + res + '</div>').find(
              '.collection-listing'
            )
            newDetailHtml($newDetailAll)
          }
        )
      }
    })
    function newDetailHtml($newDetail) {
      $newDetail.find('.product-list').children('.product-block:gt(3)').remove()
      $newDetail
        .find('.product-list')
        .children('.product-block')
        .removeAttr('data-cc-animate')
      $('.findSize-bra-fit-product').html($newDetail)
      const $nonSectionedProductLists = $('.product-list, .collection-listing')
      console.log($nonSectionedProductLists, 'non sectioned product')
      if ($nonSectionedProductLists.length > 0) {
        theme.ProductBlockManager.loadImages($nonSectionedProductLists)
      }
    }
  }
  $('.findSize-bra-fit-qa-a-but button').click(function () {
    window.location.href = queryUrl
    // console.log(queryUrl)
  })
  function queryRecordBraFitQA({
    questionId = '',
    question = '',
    answer = '',
    callback
  }) {
    const data = {
      userId: __st.cid,
      visitorId: getVisitorId(),
      formId: null,
      questionId,
      question,
      answer
    }
    $.ajax({
      type: 'POST',
      url: `${addressUrl}/recordBraFitQA`,
      data,
      success: function (res) {
        callback && callback(res)
      }
    })
  }
  const urlEncode = (obj) => {
    let params = Object.keys(obj)
      .map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
      })
      .join('&')
    return params
  }
  const urlOccasionEncode = (param) => {
    let params = param
      .map((key) => {
        return 'filter.p.m.custom.occassion=' + encodeURIComponent(key)
      })
      .join('&')
    return params
  }
  setTimeout(() => {
    $('.findSize-navigation').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    })
  }, 100)
})
